export default "__VITE_ASSET__BUrTgZH2__ 224w, __VITE_ASSET__B8BWzq1F__ 448w";